module.exports = __webpack_public_path__ + "img/HU.4eb09ec4.svg";